<template>
  <div class="calendar-tile" :class="`calendar-tile--${tile.status}`">
    <div class="calendar-tile__month">
      {{ $getFormattedDate(tile.plan_date, "MMMM") }}
    </div>
    <div v-if="tile.status !== 'NO_PAYMENT'" class="calendar-tile__content">
      <div
        class="calendar-tile__status"
        :class="`calendar-tile__status--${tile.status}`"
      >
        {{ $getFormattedDate(this.tile.plan_date, "DD") }}
      </div>
      <div
        class="calendar-tile__amount"
        :class="{
          [`calendar-tile__amount--${tile.status}`]: true,
          'calendar-tile__amount--dim':
            !isCurrentPayment || tile.status === 'PAID',
        }"
      >
        <template v-if="tile.status === 'PAID'">
          {{ $currencyFormatter(tile.paid) }}
        </template>
        <template v-else>{{ $currencyFormatter(tile.to_pay) }}</template>
      </div>
      <div
        v-if="tile.status !== 'PAID' && tile.status !== 'NO_PAYMENT'"
        class="calendar-tile__additional"
        :class="{
          [`calendar-tile__additional--${tile.status}`]: true,
          'calendar-tile__additional--box':
            isFirstPrepayment || isPaymentRequired,
        }"
        v-html="titleText"
      ></div>
    </div>
    <div v-else class="calendar-tile__content--no-bill">
      {{ $t`Нет счетов на оплату` }}
    </div>
  </div>
</template>

<script>
import { getDateText } from "@/utils/date";

export default {
  name: "PaymentCalendarTile",
  props: {
    tile: {
      type: Object,
      required: true,
    },
    isCurrentPayment: {
      type: Boolean,
      default: false,
    },
    isFirstPrepayment: {
      type: Boolean,
      required: true,
    },
  },
  computed: {
    titleText() {
      if (this.tile.status == "FOR_PAYMENT") {
        return this.$l10nformat(this.$t`Оплатить до </br> #DATE#`, {
          DATE: getDateText(this.tile.plan_date, "dative", "D MMMM"),
        });
      }

      if (this.tile.status == "PRE_PAYMENT") {
        if (this.isFirstPrepayment) {
          return this.$l10nformat(this.$t`Будет выставлен </br> #DATE#`, {
            DATE: getDateText(this.tile.open_date, "accusative", "D MMMM"),
          });
        }
        return this.$t`Подробнее`;
      }

      if (this.tile.status === "WAS_OVERDUE") {
        return this.$t`Вы на </br> просрочке!`;
      }

      return null;
    },
    isPaymentRequired() {
      return (
        this.tile.status === "FOR_PAYMENT" ||
        this.tile.status === "OVERDUE" ||
        this.tile.status === "WAS_OVERDUE"
      );
    },
  },
};
</script>

<style lang="scss" scoped>
@import "@/assets/styles/colors.scss";

.calendar-tile {
  padding: 15px 8px 8px;
  min-height: 165px;
  font-family: "Roboto-Regular";
  display: flex;
  flex-direction: column;
  align-items: center;
  background: $colorWhite;
  overflow: hidden;
  border: 1px solid $colorGrayBorder;

  &__month {
    color: $colorBlack;
    font-size: 17px;
    line-height: 20px;
    color: #4a4a4a;
    padding-bottom: 10px;
    text-transform: capitalize;
  }

  &--NO_PAYMENT {
    background: #f5f5f5;

    .calendar-tile__month {
      color: #9b9b9b;
    }
  }

  &__content {
    display: flex;
    justify-content: center;
    align-items: center;
    flex-direction: column;

    &--no-bill {
      background: #f5f5f5;
      background: $colorSmoke;
      font-size: 14px;
      line-height: 14px;
      color: #9b9b9b;
      text-align: center;
      padding: 10px 20px 0px 20px;
    }
  }

  &__status {
    font-size: 17px;
    line-height: 40px;
    width: 40px;
    height: 40px;
    display: flex;
    align-items: center;
    justify-content: center;
    border-radius: 50%;
    text-align: center;
    box-shadow: 0px 0px 0px 1px #e0e0e0;

    &--PAID {
      box-shadow: none;
      color: transparent;
      background-image: url(~@/assets/i-ok-credit.png);
      background-repeat: no-repeat;
      background-position: center;
      background-size: 40px auto;
    }
  }

  &__amount {
    color: $colorBlack;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
    padding: 10px 0 4px;
    font-size: 17px;
    line-height: 20px;

    &--dim {
      color: #9b9b9b !important;
    }
  }

  &__additional {
    flex: 1;
    width: 105px;
    height: 36px;
    color: $colorCerulean;
    font-size: 12px;
    line-height: 14px;
    background-color: #fff;
    border-radius: 2px;
    overflow: hidden;

    &--box {
      white-space: nowrap;
      padding: 4px;
      -webkit-box-shadow: 0px 0px 0px 1px #e0e0e0;
      -moz-box-shadow: 0px 0px 0px 1px #e0e0e0;
      box-shadow: 0px 0px 0px 1px #e0e0e0;
    }

    &--WAS_OVERDUE {
      background-color: black;
      color: white;
      box-shadow: none;
    }

    &--FOR_PAYMENT {
      color: $colorRed;
    }
  }
}
</style>
